'use client';
import type { JSX } from 'react';

import clsx from 'clsx';

import { testIds } from '@/components/constants/testIds';
import useI18n from '@/hooks/useI18n';

import Text from '../Text';

type LanguageSwitcherProps = {
    className?: string;
    testId?: string;
};

export default function LanguageSwitcher({ className, testId = testIds.languageSwitcher.base }: LanguageSwitcherProps): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: States & Constants
    // ----------------------------------------------------------------------------------------------------
    const { t, locale, changeLocale } = useI18n();

    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <div
            data-testid={testId}
            className={clsx('border border-slate-100 dark:border-neutral-800 py-2 px-4 rounded-full hover:text-accent-500', className)}
        >
            {locale === 'ar' && (
                <button className="flex gap-2" data-testid={testIds.languageSwitcher.button} onClick={() => changeLocale('en')}>
                    <Text testId={testIds.languageSwitcher.text} size="sm" color="none">
                        🇺🇸
                    </Text>
                    <Text testId={testIds.languageSwitcher.text} size="sm" color="none">
                        {t('Locales.English')}
                    </Text>
                </button>
            )}

            {locale === 'en' && (
                <button className="flex gap-2" data-testid={testIds.languageSwitcher.button} onClick={() => changeLocale('ar')}>
                    <Text testId={testIds.languageSwitcher.text} size="sm" color="none">
                        🇪🇬
                    </Text>
                    <Text testId={testIds.languageSwitcher.text} size="sm" color="none">
                        {t('Locales.Arabic')}
                    </Text>
                </button>
            )}
        </div>
    );
}
